export default __webpack_public_path__ + "682779095ceb771b8df83472f660fa5a.jpg";